import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import throttle from 'raf-throttle';

import styles from './load-more.scss';
import Wix from '../../services/wix-sdk-polyfill';
import scrollParent from '../../services/scroll-parent';
import Loader from '../loader';

const classNames = require('classnames');

class LoadMore extends React.Component {
  shouldLoadMore = (position) => {
    const end = scrollParent().scrollHeight;
    return position > end && this.props.hasMore && !this.props.isLoading;
  };

  onMobileScroll = throttle(() => {
    const position = scrollParent().scrollTop + scrollParent().offsetHeight + this.props.threshold;
    if (this.shouldLoadMore(position)) {
      this.loadMore();
    }
  });

  onScroll = throttle(({ scrollTop, documentHeight }) => {
    const position = scrollTop + documentHeight + this.props.threshold;
    if (this.shouldLoadMore(position)) {
      this.loadMore();
    }
  });

  loadMore = () => {
    this.props.loadMore(this.page);
    this.page++;
  };

  componentDidMount = () => {
    this.page = this.props.pageStart;
    this.startListening();
  };

  componentWillUnmount = () => {
    this.stopListening();
  };

  startListening = () => {
    Wix.addEventListener(Wix.Events.SCROLL, this.onScroll);
    scrollParent().addEventListener('scroll', this.onMobileScroll);
  };

  stopListening = () => {
    Wix.removeEventListener(Wix.Events.SCROLL, this.onScroll);
    scrollParent().removeEventListener('scroll', this.onMobileScroll);
  };

  render = () => {
    const { element: Element, children, loader, hasMore, isLoading, isMobile, ...props } = this.props;
    const passProps = _.omit(props, ['loadMore', 'isLoading', 'pageStart', 'threshold', 'dispatch']);

    return (
      <Element {...passProps}>
        {children}
        {hasMore &&
          isLoading &&
          (loader || (
            <div className={classNames(styles.loader, isMobile && styles.mobile)}>
              <Loader className="ma-lazy-list-loader" size={isMobile ? 'small' : 'medium'} />
            </div>
          ))}
      </Element>
    );
  };
}

LoadMore.propTypes = {
  element: PropTypes.string,
  scroll: PropTypes.object,
  children: PropTypes.node,
  loader: PropTypes.node,
  hasMore: PropTypes.bool,
  loadMore: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  pageStart: PropTypes.number,
  threshold: PropTypes.number,
  isMobile: PropTypes.bool,
};

LoadMore.defaultProps = {
  element: 'div',
  hasMore: false,
  pageStart: 2,
  threshold: 500,
};

export default LoadMore;
